// extracted by mini-css-extract-plugin
module.exports = {"button":"style__button__N8N-O"};